(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-tiles"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('.category-tiles[data-section-id]');
  
  sections.forEach(section => {
    const container = section.querySelector('.category-tiles__container');
    const track = section.querySelector('[data-slider-track]');
    const prevBtn = section.querySelector('[data-slider-prev]');
    const nextBtn = section.querySelector('[data-slider-next]');
    
    if (!container || !track) return;
    
    const totalCards = parseInt(container.dataset.totalCards) || 0;
    const isSliderMobile = container.dataset.sliderMobile === 'true';
    const isSliderDesktop = container.dataset.sliderDesktop === 'true';
    
    let currentIndex = 0;
    let isTransitioning = false;
    
    // Responsive cards per page
    const getCardsPerPage = () => {
      const width = window.innerWidth;
      if (width < 768) return 1;
      if (width < 1024) return 2;
      if (width < 1400) return 3;
      return 4;
    };
    
    // Check if slider mode is active
    const isSliderActive = () => {
      const width = window.innerWidth;
      if (width < 768) return isSliderMobile;
      return isSliderDesktop;
    };
    
    let cardsPerPage = getCardsPerPage();
    let maxSlides = Math.max(0, totalCards - cardsPerPage);
    
    // Update arrow visibility
    const updateArrows = () => {
      if (!prevBtn || !nextBtn) return;
      
      maxSlides = Math.max(0, totalCards - cardsPerPage);
      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = currentIndex >= maxSlides;
      
      // Hide/show arrows based on slider mode
      const sliderActive = isSliderActive();
      prevBtn.style.display = sliderActive && totalCards > cardsPerPage ? 'flex' : 'none';
      nextBtn.style.display = sliderActive && totalCards > cardsPerPage ? 'flex' : 'none';
    };
    
    // Go to specific slide
    const goToSlide = (index) => {
      if (isTransitioning || !isSliderActive()) return;
      isTransitioning = true;
      
      currentIndex = Math.max(0, Math.min(index, maxSlides));
      
      const slides = track.querySelectorAll('.category-tile');
      if (slides.length > 0) {
        const slideWidth = slides[0].getBoundingClientRect().width;
        const gap = parseInt(getComputedStyle(track).gap) || 20;
        track.style.transform = `translateX(-${currentIndex * (slideWidth + gap)}px)`;
      }
      
      updateArrows();
      setTimeout(() => { isTransitioning = false; }, 500);
    };
    
    // Reset slider position
    const resetSlider = () => {
      if (!isSliderActive()) {
        track.style.transform = 'translateX(0)';
        currentIndex = 0;
      }
      updateArrows();
    };
    
    // Event listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) goToSlide(currentIndex - 1);
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        if (currentIndex < maxSlides) goToSlide(currentIndex + 1);
      });
    }
    
    // Touch swipe support
    let touchStartX = 0;
    let touchEndX = 0;
    const minSwipeDistance = 50;
    
    track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const swipeDistance = touchStartX - touchEndX;
      
      if (Math.abs(swipeDistance) > minSwipeDistance && isSliderActive()) {
        if (swipeDistance > 0 && currentIndex < maxSlides) {
          goToSlide(currentIndex + 1);
        } else if (swipeDistance < 0 && currentIndex > 0) {
          goToSlide(currentIndex - 1);
        }
      }
    }, { passive: true });
    
    // Resize handler
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const newCardsPerPage = getCardsPerPage();
        if (newCardsPerPage !== cardsPerPage) {
          cardsPerPage = newCardsPerPage;
          maxSlides = Math.max(0, totalCards - cardsPerPage);
          if (currentIndex > maxSlides) currentIndex = maxSlides;
          goToSlide(currentIndex);
        }
        resetSlider();
      }, 250);
    });
    
    // Initialize
    updateArrows();
    resetSlider();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-page"]) return;
  try {
    
  (function() {
    const collectionPage = document.querySelector('[data-collection-page]');
    if (!collectionPage) return;

    const productsContainer = collectionPage.querySelector('[data-products-container]');
    const productsGrid = collectionPage.querySelector('[data-products-grid]');
    const mainContent = collectionPage.querySelector('.collection-page__main');
    const loader = collectionPage.querySelector('[data-infinite-loader]');
    const activeFiltersContainer = collectionPage.querySelector('[data-active-filters]');
    const productsCountEl = collectionPage.querySelector('[data-products-count]');
    const filterDrawer = collectionPage.querySelector('[data-filter-drawer]');
    const filterToggle = collectionPage.querySelector('[data-filter-toggle]');
    const filterClose = collectionPage.querySelectorAll('[data-filter-close]');
    const floatingFilterBtn = collectionPage.querySelector('[data-floating-filter]');
    
    let isLoading = false;

    function openFilterDrawer() {
      if (filterDrawer) {
        filterDrawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    }

    function closeFilterDrawer() {
      if (filterDrawer) {
        filterDrawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }

    if (filterToggle) {
      filterToggle.addEventListener('click', openFilterDrawer);
    }

    if (floatingFilterBtn) {
      floatingFilterBtn.addEventListener('click', openFilterDrawer);
    }

    filterClose.forEach(el => {
      el.addEventListener('click', closeFilterDrawer);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && filterDrawer?.classList.contains('is-open')) {
        closeFilterDrawer();
      }
    });

    // Get the correct filter form (prefer sidebar form for desktop, mobile drawer when open)
    function getActiveFilterForm() {
      // If mobile drawer is open, use its form
      if (filterDrawer && filterDrawer.classList.contains('is-open')) {
        return filterDrawer.querySelector('.facets-form');
      }
      // Otherwise use the sidebar form (desktop)
      const sidebar = collectionPage.querySelector('[data-filters-sidebar]');
      if (sidebar) {
        return sidebar.querySelector('.facets-form');
      }
      // Fallback to any form
      return collectionPage.querySelector('.facets-form');
    }

    // AJAX Filtering - Matches Skechers implementation
    function applyFilters() {
      const form = getActiveFilterForm();
      if (!form) return;
      
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData);
      
      // Get sort value from the select element (not URL)
      const sortSelect = collectionPage.querySelector('[data-sort-select]');
      if (sortSelect && sortSelect.value) {
        searchParams.set('sort_by', sortSelect.value);
      }
      
      // Remove empty values
      const keysToDelete = [];
      for (let [key, value] of searchParams.entries()) {
        if (!value || value === '') {
          keysToDelete.push(key);
        }
      }
      keysToDelete.forEach(key => searchParams.delete(key));
      
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      fetchFilteredProducts(newUrl);
    }

    function fetchFilteredProducts(url, pushState = true) {
      if (isLoading) return;
      isLoading = true;
      
      if (mainContent) mainContent.classList.add('is-loading');

      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Update products grid
          const newContainer = doc.querySelector('[data-products-container]');
          if (newContainer && productsContainer) {
            productsContainer.innerHTML = newContainer.innerHTML;
          }

          // Update active filters (in all locations)
          const newActiveFilters = doc.querySelector('.active-filters-wrapper');
          const currentActiveFiltersList = collectionPage.querySelectorAll('.active-filters-wrapper');
          if (newActiveFilters && currentActiveFiltersList.length) {
            currentActiveFiltersList.forEach(el => {
              el.innerHTML = newActiveFilters.innerHTML;
            });
          }

          // Update products count
          const newCount = doc.querySelector('[data-products-count]');
          if (newCount && productsCountEl) {
            productsCountEl.innerHTML = newCount.innerHTML;
          }

          // Update desktop filters to match new state
          updateFiltersFromResponse(doc);

          // Update URL without reload
          if (pushState) {
            window.history.pushState({}, '', url);
          }

          // Reset infinite scroll state
          hasMore = !!document.getElementById('next-page-url');
          setupInfiniteScroll();

          isLoading = false;
          if (mainContent) mainContent.classList.remove('is-loading');
          
          // Close mobile drawer
          closeFilterDrawer();
        })
        .catch(error => {
          console.error('Error fetching filtered products:', error);
          // Fallback to page reload
          window.location.href = url;
        });
    }

    function updateFiltersFromResponse(doc) {
      // Update sidebar filters (desktop)
      const newSidebarFilters = doc.querySelector('[data-filters-sidebar]');
      const currentSidebarFilters = collectionPage.querySelector('[data-filters-sidebar]');
      
      if (newSidebarFilters && currentSidebarFilters) {
        currentSidebarFilters.innerHTML = newSidebarFilters.innerHTML;
      }
      
      // Update mobile drawer filters
      const newDrawerBody = doc.querySelector('.collection-page__filter-drawer-body');
      const currentDrawerBody = collectionPage.querySelector('.collection-page__filter-drawer-body');
      
      if (newDrawerBody && currentDrawerBody) {
        currentDrawerBody.innerHTML = newDrawerBody.innerHTML;
      }
      
      // Re-attach event listeners after replacing content
      attachFilterListeners();
      // Re-initialize price sliders
      initPriceSliders();
    }

    function resetPriceSliders() {
      // Reset price sliders in all forms
      const forms = collectionPage.querySelectorAll('.facets-form');
      forms.forEach(form => {
        const priceContainers = form.querySelectorAll('.filter-price-range');
        priceContainers.forEach(container => {
          const minSlider = container.querySelector('.price-slider-min');
          const maxSlider = container.querySelector('.price-slider-max');
          const sliderRange = container.querySelector('.price-slider-range');
          const rangeMin = parseFloat(container.dataset.min) || 0;
          const rangeMax = parseFloat(container.dataset.max) || 1000;

          if (minSlider) minSlider.value = rangeMin;
          if (maxSlider) maxSlider.value = rangeMax;
          if (sliderRange) {
            sliderRange.style.left = '0%';
            sliderRange.style.width = '100%';
          }
        });
      });
    }

    // Initialize Price Sliders
    function initPriceSliders() {
      const priceContainers = document.querySelectorAll('.filter-price-range');
      
      priceContainers.forEach(container => {
        const minSlider = container.querySelector('.price-slider-min');
        const maxSlider = container.querySelector('.price-slider-max');
        const minInput = container.querySelector('.filter-price-min');
        const maxInput = container.querySelector('.filter-price-max');
        const sliderRange = container.querySelector('.price-slider-range');
        
        if (!minSlider || !maxSlider || !minInput || !maxInput) return;
        
        const rangeMin = parseFloat(container.dataset.min) || 0;
        const rangeMax = parseFloat(container.dataset.max) || 1000;
        const minGap = 1;
        
        function updateSliderRange() {
          const minVal = parseFloat(minSlider.value);
          const maxVal = parseFloat(maxSlider.value);
          const minPercent = ((minVal - rangeMin) / (rangeMax - rangeMin)) * 100;
          const maxPercent = ((maxVal - rangeMin) / (rangeMax - rangeMin)) * 100;
          sliderRange.style.left = minPercent + '%';
          sliderRange.style.width = (maxPercent - minPercent) + '%';
        }
        
        function clampMin(val) {
          const max = parseFloat(maxSlider.value) || rangeMax;
          if (isNaN(val) || val < rangeMin) return rangeMin;
          if (val >= max) return max - minGap;
          return Math.round(val);
        }
        
        function clampMax(val) {
          const min = parseFloat(minSlider.value) || rangeMin;
          if (isNaN(val) || val > rangeMax) return rangeMax;
          if (val <= min) return min + minGap;
          return Math.round(val);
        }
        
        // Min slider change
        minSlider.addEventListener('input', function() {
          let minVal = parseFloat(this.value);
          let maxVal = parseFloat(maxSlider.value);
          if (minVal >= maxVal) {
            minVal = maxVal - minGap;
            this.value = minVal;
          }
          minInput.value = Math.round(minVal);
          updateSliderRange();
        });
        
        // Max slider change
        maxSlider.addEventListener('input', function() {
          let maxVal = parseFloat(this.value);
          let minVal = parseFloat(minSlider.value);
          if (maxVal <= minVal) {
            maxVal = minVal + minGap;
            this.value = maxVal;
          }
          maxInput.value = Math.round(maxVal);
          updateSliderRange();
        });
        
        // Min input change
        minInput.addEventListener('input', function() {
          const val = parseFloat(this.value);
          if (!isNaN(val) && val >= rangeMin && val <= rangeMax) {
            minSlider.value = val;
            updateSliderRange();
          }
        });
        
        minInput.addEventListener('blur', function() {
          if (this.value === '') return;
          const corrected = clampMin(parseFloat(this.value));
          this.value = corrected;
          minSlider.value = corrected;
          updateSliderRange();
        });
        
        minInput.addEventListener('keypress', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.blur();
          }
        });
        
        // Max input change
        maxInput.addEventListener('input', function() {
          const val = parseFloat(this.value);
          if (!isNaN(val) && val >= rangeMin && val <= rangeMax) {
            maxSlider.value = val;
            updateSliderRange();
          }
        });
        
        maxInput.addEventListener('blur', function() {
          if (this.value === '') return;
          const corrected = clampMax(parseFloat(this.value));
          this.value = corrected;
          maxSlider.value = corrected;
          updateSliderRange();
        });
        
        maxInput.addEventListener('keypress', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.blur();
          }
        });
        
        // Initialize slider range visual
        updateSliderRange();
        
        // GO button
        const goBtn = container.querySelector('.price-filter-go-btn');
        if (goBtn) {
          goBtn.addEventListener('click', function() {
            applyFilters();
          });
        }
      });
    }
    
    // Attach filter event listeners
    function attachFilterListeners() {
      // Filter checkbox changes - attach to all forms
      const allFacetForms = collectionPage.querySelectorAll('.facets-form');
      allFacetForms.forEach(form => {
        form.querySelectorAll('.filter-input').forEach(input => {
          input.removeEventListener('change', handleFilterChange); // Remove old listeners
          input.addEventListener('change', handleFilterChange);
        });
      });
    }
    
    function handleFilterChange(e) {
      const input = e.target;
      const inputName = input.name;
      const inputValue = input.value;
      const isChecked = input.checked;
      
      // Sync the same checkbox in other forms
      const allFacetForms = collectionPage.querySelectorAll('.facets-form');
      allFacetForms.forEach(form => {
        const matchingInput = form.querySelector(`input[name="${inputName}"][value="${inputValue}"]`);
        if (matchingInput && matchingInput !== input) {
          matchingInput.checked = isChecked;
        }
      });
      
      applyFilters();
    }

    // Filter checkbox changes - attach to all forms
    const allFacetForms = collectionPage.querySelectorAll('.facets-form');
    allFacetForms.forEach(form => {
      form.querySelectorAll('.filter-input').forEach(input => {
        input.addEventListener('change', handleFilterChange);
      });
    });

    // Initialize price sliders
    initPriceSliders();

    // Handle Clear All, active filter removal, and filter group clear
    document.addEventListener('click', function(e) {
      const clearAllBtn = e.target.closest('.collection-filters__clear');
      const activeFilter = e.target.closest('.active-filter');
      const clearFiltersBtn = e.target.closest('[data-clear-filters]');
      
      if (clearAllBtn || activeFilter || clearFiltersBtn) {
        e.preventDefault();
        const url = (clearAllBtn || activeFilter || clearFiltersBtn).getAttribute('href');
        
        fetch(url)
          .then(response => response.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            
            // Update products
            const newContainer = doc.querySelector('[data-products-container]');
            if (newContainer && productsContainer) {
              productsContainer.innerHTML = newContainer.innerHTML;
            }
            
            // Update active filters (in all locations)
            const newActiveFilters = doc.querySelector('.active-filters-wrapper');
            const currentActiveFiltersList = collectionPage.querySelectorAll('.active-filters-wrapper');
            if (newActiveFilters && currentActiveFiltersList.length) {
              currentActiveFiltersList.forEach(el => {
                el.innerHTML = newActiveFilters.innerHTML;
              });
            }
            
            // Update products count
            const newCount = doc.querySelector('[data-products-count]');
            if (newCount && productsCountEl) {
              productsCountEl.innerHTML = newCount.innerHTML;
            }
            
            // Always update filters from server response - this ensures all filter options are restored
            updateFiltersFromResponse(doc);
            
            // Reset price sliders if clearing all
            if (clearAllBtn || clearFiltersBtn) {
              resetPriceSliders();
              // Reset sort dropdown to first option
              const sortSelect = collectionPage.querySelector('.collection-page__sort-select');
              if (sortSelect && sortSelect.options.length > 0) {
                sortSelect.selectedIndex = 0;
              }
            }
            
            window.history.pushState({}, '', url);
            
            // Reset infinite scroll state
            hasMore = !!document.getElementById('next-page-url');
            setupInfiniteScroll();
            
            isLoading = false;
            if (mainContent) mainContent.classList.remove('is-loading');
            closeFilterDrawer();
          })
          .catch(() => window.location.href = url);
        
        return;
      }
    });

    // Sort select change
    const sortSelect = collectionPage.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        applyFilters();
      });
    }

    // Browser back/forward
    window.addEventListener('popstate', () => {
      fetchFilteredProducts(window.location.href, false);
    });

    // Infinite Scroll - Scroll-based approach (like skechers-theme)
    const scrollThreshold = 1500; // Load when within 1500px of bottom
    let hasMore = !!document.getElementById('next-page-url');

    function checkScroll() {
      if (isLoading || !hasMore) return;

      const nextPageUrlEl = document.getElementById('next-page-url');
      if (!nextPageUrlEl) {
        hasMore = false;
        return;
      }

      const scrollPosition = window.innerHeight + window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      const threshold = pageHeight - scrollThreshold;

      if (scrollPosition >= threshold) {
        loadMoreProducts();
      }
    }

    function loadMoreProducts() {
      if (isLoading) return;

      const nextPageUrlEl = document.getElementById('next-page-url');
      if (!nextPageUrlEl) return;

      isLoading = true;
      const url = nextPageUrlEl.dataset.url;
      const loadingIndicator = document.getElementById('collection-loading-indicator');

      if (loadingIndicator) loadingIndicator.style.display = 'flex';

      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const gridEl = collectionPage.querySelector('[data-products-grid]');
          const newProducts = doc.querySelectorAll('[data-products-grid] > *');
          
          newProducts.forEach(product => {
            gridEl.appendChild(product.cloneNode(true));
          });

          // Check for next page
          const newNextUrl = doc.getElementById('next-page-url');
          if (newNextUrl) {
            nextPageUrlEl.dataset.url = newNextUrl.dataset.url;
          } else {
            nextPageUrlEl.remove();
            hasMore = false;
            if (loadingIndicator) loadingIndicator.style.display = 'none';
            // Show end message
            const endEl = document.createElement('div');
            endEl.className = 'collection-page__end';
            endEl.id = 'collection-end';
            endEl.innerHTML = "<span>You've viewed all products</span>";
            gridEl.parentNode.appendChild(endEl);
          }

          isLoading = false;
          if (loadingIndicator) loadingIndicator.style.display = 'none';
        })
        .catch(error => {
          console.error('Error loading more products:', error);
          isLoading = false;
          const loadingIndicator = document.getElementById('collection-loading-indicator');
          if (loadingIndicator) loadingIndicator.style.display = 'none';
        });
    }

    function setupInfiniteScroll() {
      hasMore = !!document.getElementById('next-page-url');
    }

    // Attach scroll listener
    window.addEventListener('scroll', checkScroll);
    setupInfiniteScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Back to Top Button Functionality
  const backToTopBtn = document.getElementById('backToTop');
  
  if (backToTopBtn) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 300) {
        backToTopBtn.classList.add('visible');
      } else {
        backToTopBtn.classList.remove('visible');
      }
    });

    backToTopBtn.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // ================================
    // Full-Page Mega Search Functionality
    // ================================
    const searchMega = document.querySelector('[data-search-mega]');
    const searchMegaOverlay = document.querySelector('[data-search-mega-overlay]');
    const searchMegaClose = document.querySelectorAll('[data-search-mega-close]');
    const searchMegaClear = document.querySelector('[data-search-mega-clear]');
    const searchMegaInput = document.querySelector('[data-search-mega-input]');
    const searchMegaDefault = document.querySelector('[data-search-mega-default]');
    const searchMegaResults = document.querySelector('[data-search-mega-results]');
    const searchNoResults = document.querySelector('[data-search-no-results]');
    const searchViewAll = document.querySelector('[data-search-view-all]');
    
    // Header search bar trigger
    const headerSearchInput = document.querySelector('[data-predictive-search-input]');
    const headerSearchForm = document.querySelector('[data-predictive-search-form]');
    
    // Popular search tags
    const searchTags = document.querySelectorAll('[data-search-term]');
    
    let searchTimeout = null;
    let currentQuery = '';
    const DEBOUNCE_DELAY = 300;
    const MIN_QUERY_LENGTH = 2;
    
    // Open mega search when clicking header search (desktop)
    if (headerSearchInput) {
      headerSearchInput.addEventListener('focus', openMegaSearch);
      headerSearchInput.addEventListener('click', openMegaSearch);
    }
    
    if (headerSearchForm) {
      headerSearchForm.addEventListener('submit', function(e) {
        e.preventDefault();
        openMegaSearch();
      });
    }
    
    // Open mega search from mobile header search bar
    const mobileSearchTrigger = document.querySelector('[data-mobile-search-trigger]');
    if (mobileSearchTrigger) {
      mobileSearchTrigger.addEventListener('click', openMegaSearch);
    }

    // Open mega search from compact scrolled header search
    const compactSearchTrigger = document.querySelector('[data-compact-search-trigger]');
    if (compactSearchTrigger) {
      compactSearchTrigger.addEventListener('click', openMegaSearch);
    }
    
    // Close mega search (back button)
    searchMegaClose.forEach(btn => {
      btn.addEventListener('click', closeMegaSearch);
    });
    
    if (searchMegaOverlay) {
      searchMegaOverlay.addEventListener('click', closeMegaSearch);
    }
    
    // Clear search input (X button)
    if (searchMegaClear) {
      searchMegaClear.addEventListener('click', clearSearch);
    }
    
    // Escape key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchMega && searchMega.classList.contains('is-open')) {
        closeMegaSearch();
      }
    });
    
    // Popular search tags click
    searchTags.forEach(tag => {
      tag.addEventListener('click', function(e) {
        e.preventDefault();
        const term = this.dataset.searchTerm;
        if (searchMegaInput) {
          searchMegaInput.value = term;
          updateClearButtonVisibility();
          performSearch(term);
        }
      });
    });
    
    // Handle mega search input
    if (searchMegaInput) {
      searchMegaInput.addEventListener('input', function() {
        const query = this.value.trim();
        
        updateClearButtonVisibility();
        clearTimeout(searchTimeout);
        
        if (query.length < MIN_QUERY_LENGTH) {
          showDefaultContent();
          return;
        }
        
        searchTimeout = setTimeout(() => {
          if (query !== currentQuery) {
            currentQuery = query;
            performSearch(query);
          }
        }, DEBOUNCE_DELAY);
      });
    }
    
    function openMegaSearch() {
      if (searchMega) {
        searchMega.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        
        // Focus the mega search input after animation
        setTimeout(() => {
          if (searchMegaInput) {
            searchMegaInput.focus();
            // Copy value from header search if any
            if (headerSearchInput && headerSearchInput.value) {
              searchMegaInput.value = headerSearchInput.value;
              updateClearButtonVisibility();
              if (headerSearchInput.value.length >= MIN_QUERY_LENGTH) {
                performSearch(headerSearchInput.value);
              }
            }
          }
        }, 400);
      }
    }
    
    function closeMegaSearch() {
      if (searchMega) {
        searchMega.classList.remove('is-open');
        document.body.style.overflow = '';
        currentQuery = '';
        
        // Clear inputs
        if (searchMegaInput) searchMegaInput.value = '';
        if (headerSearchInput) headerSearchInput.value = '';
        
        // Hide clear button
        updateClearButtonVisibility();
        
        // Reset to default view
        showDefaultContent();
      }
    }
    
    function clearSearch() {
      if (searchMegaInput) {
        searchMegaInput.value = '';
        searchMegaInput.focus();
      }
      if (headerSearchInput) {
        headerSearchInput.value = '';
      }
      currentQuery = '';
      updateClearButtonVisibility();
      showDefaultContent();
    }
    
    function updateClearButtonVisibility() {
      if (searchMegaClear && searchMegaInput) {
        if (searchMegaInput.value.length > 0) {
          searchMegaClear.classList.add('is-visible');
        } else {
          searchMegaClear.classList.remove('is-visible');
        }
      }
    }
    
    function showDefaultContent() {
      if (searchMegaDefault) searchMegaDefault.style.display = '';
      if (searchMegaResults) searchMegaResults.style.display = 'none';
      if (searchNoResults) searchNoResults.style.display = 'none';
      if (searchViewAll) searchViewAll.style.display = 'none';
    }
    
    function showResultsContent() {
      if (searchMegaDefault) searchMegaDefault.style.display = 'none';
      if (searchMegaResults) searchMegaResults.style.display = '';
    }
    
    async function performSearch(query) {
      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku`
        );
        
        if (!response.ok) throw new Error('Search failed');
        
        const data = await response.json();
        renderResults(data.resources.results, query);
        showResultsContent();
      } catch (error) {
        console.error('Search error:', error);
      }
    }
    
    function renderResults(results, query) {
      const productsSection = document.querySelector('[data-results-section="products"]');
      const collectionsSection = document.querySelector('[data-results-section="collections"]');
      const pagesSection = document.querySelector('[data-results-section="pages"]');
      const productsContainer = document.querySelector('[data-results-products]');
      const collectionsContainer = document.querySelector('[data-results-collections]');
      const pagesContainer = document.querySelector('[data-results-pages]');
      
      let hasResults = false;
      
      // Render products
      if (results.products && results.products.length > 0) {
        hasResults = true;
        productsSection.classList.add('has-results');
        productsContainer.innerHTML = results.products.map(product => {
          const image = product.image ? 
            `<img src="${getSizedImageUrl(product.image, '300x')}" alt="${escapeHtml(product.title)}" loading="lazy">` :
            `<div class="search-mega__result-image--placeholder"><span class="material-symbols-outlined">image</span></div>`;
          
          const price = formatMoney(product.price);
          const isOnSale = product.compare_at_price_max > product.price;
          const comparePrice = isOnSale ? 
            `<s>${formatMoney(product.compare_at_price_max)}</s>` : '';
          const priceClass = isOnSale ? 'search-mega__result-price--sale' : '';
          const discountPct = isOnSale ? Math.round((product.compare_at_price_max - product.price) / product.compare_at_price_max * 100) : 0;
          const badge = isOnSale ? `<span class="search-mega__result-badge">-${discountPct}%</span>` : '';
          
          return `
            <a href="${product.url}" class="search-mega__result-product">
              <div class="search-mega__result-image">${image}${badge}</div>
              <span class="search-mega__result-title">${highlightMatch(product.title, query)}</span>
              <span class="search-mega__result-price ${priceClass}">${comparePrice}${price}</span>
            </a>
          `;
        }).join('');
      } else {
        productsSection.classList.remove('has-results');
        productsContainer.innerHTML = '';
      }
      
      // Render collections
      if (results.collections && results.collections.length > 0) {
        hasResults = true;
        collectionsSection.classList.add('has-results');
        collectionsContainer.innerHTML = results.collections.map(collection => `
          <a href="${collection.url}" class="search-mega__results-item">
            <span class="search-mega__results-item-icon">
              <span class="material-symbols-outlined">category</span>
            </span>
            <span class="search-mega__results-item-text">${highlightMatch(collection.title, query)}</span>
          </a>
        `).join('');
      } else {
        collectionsSection.classList.remove('has-results');
        collectionsContainer.innerHTML = '';
      }
      
      // Render pages
      if (results.pages && results.pages.length > 0) {
        hasResults = true;
        pagesSection.classList.add('has-results');
        pagesContainer.innerHTML = results.pages.map(page => `
          <a href="${page.url}" class="search-mega__results-item">
            <span class="search-mega__results-item-icon">
              <span class="material-symbols-outlined">article</span>
            </span>
            <span class="search-mega__results-item-text">${highlightMatch(page.title, query)}</span>
          </a>
        `).join('');
      } else {
        pagesSection.classList.remove('has-results');
        pagesContainer.innerHTML = '';
      }
      
      // Show/hide no results
      if (searchNoResults) {
        searchNoResults.style.display = hasResults ? 'none' : '';
      }
      
      // Show/hide view all
      if (searchViewAll) {
        searchViewAll.style.display = hasResults ? '' : 'none';
        searchViewAll.href = `/search?q=${encodeURIComponent(query)}`;
      }
    }
    
    function highlightMatch(text, query) {
      if (!query) return escapeHtml(text);
      const escapedText = escapeHtml(text);
      const regex = new RegExp(`(${escapeRegex(query)})`, 'gi');
      return escapedText.replace(regex, '<mark>$1</mark>');
    }
    
    function escapeRegex(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    
    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
    
    function formatMoney(priceValue) {
      // Shopify predictive search API returns prices already formatted
      // Just ensure 2 decimal places
      const amount = parseFloat(priceValue).toFixed(2);
      return amount + ' JOD';
    }
    
    function getSizedImageUrl(url, size) {
      if (!url) return '';
      if (url.includes('_' + size)) return url;
      const match = url.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
      if (match) {
        return url.replace(match[0], '_' + size + match[0]);
      }
      return url;
    }

    // ================================
    // Mega Menu Sidebar Hover
    // ================================
    document.querySelectorAll('.header__mega-menu').forEach(menu => {
      const sidebarItems = menu.querySelectorAll('.header__mega-menu-sidebar-item');
      const contentPanels = menu.querySelectorAll('.header__mega-menu-content');
      const parentMenuItem = menu.closest('.header__menu-item');

      function resetToFirst() {
        sidebarItems.forEach(s => s.classList.remove('is-active'));
        contentPanels.forEach(p => p.classList.remove('is-active'));
        if (sidebarItems[0]) sidebarItems[0].classList.add('is-active');
        if (contentPanels[0]) contentPanels[0].classList.add('is-active');
      }

      sidebarItems.forEach(item => {
        item.addEventListener('mouseenter', function() {
          const cat = this.dataset.sidebarCategory;
          sidebarItems.forEach(s => s.classList.remove('is-active'));
          contentPanels.forEach(p => p.classList.remove('is-active'));
          this.classList.add('is-active');
          const panel = menu.querySelector('[data-content-category="' + cat + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });

      if (parentMenuItem) {
        parentMenuItem.addEventListener('mouseleave', function() {
          setTimeout(resetToFirst, 200);
        });
      }
    });

    // ================================
    // Desktop Sticky Header on Scroll
    // ================================
    const desktopHeader = document.querySelector('.header--desktop');
    if (desktopHeader) {
      const scrollThreshold = 80;
      let lastScrollY = 0;
      let ticking = false;

      function handleScroll() {
        const currentScrollY = window.scrollY;
        if (currentScrollY > scrollThreshold) {
          desktopHeader.classList.add('header--scrolled');
        } else {
          desktopHeader.classList.remove('header--scrolled');
        }
        lastScrollY = currentScrollY;
        ticking = false;
      }

      window.addEventListener('scroll', function() {
        if (!ticking) {
          requestAnimationFrame(handleScroll);
          ticking = true;
        }
      }, { passive: true });

      // Check initial state
      handleScroll();
    }
  });

  // Mobile Menu functionality
  document.addEventListener('DOMContentLoaded', function() {
    const mobileMenu = document.getElementById('mobile-menu');
    const menuTriggers = document.querySelectorAll('[data-mobile-menu-trigger]');
    const menuClose = document.querySelector('.mobile-menu__close');
    const menuOverlay = document.querySelector('.mobile-menu__overlay');

    function openMenu() {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    menuTriggers.forEach(trigger => {
      trigger.addEventListener('click', openMenu);
    });

    if (menuClose) {
      menuClose.addEventListener('click', closeMenu);
    }

    if (menuOverlay) {
      menuOverlay.addEventListener('click', closeMenu);
    }

    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        closeMenu();
      }
    });

    // Mobile dropdown toggles
    const mobileNav = document.querySelector('.mobile-menu__nav');
    const mobileToggles = document.querySelectorAll('[data-mobile-toggle]');
    
    mobileToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const group = this.closest('.mobile-menu__group');
        const isOpen = group.classList.contains('is-open');
        
        // Close all other groups
        document.querySelectorAll('.mobile-menu__group').forEach(g => {
          if (g !== group) {
            g.classList.remove('is-open');
            // Close all subcategories in other groups
            g.querySelectorAll('[data-category]').forEach(cat => {
              cat.classList.remove('is-open');
            });
          }
        });
        
        // Toggle current group
        if (isOpen) {
          group.classList.remove('is-open');
          mobileNav.classList.remove('has-open-submenu');
          // Close all subcategories in this group
          group.querySelectorAll('[data-category]').forEach(cat => {
            cat.classList.remove('is-open');
          });
        } else {
          group.classList.add('is-open');
          mobileNav.classList.add('has-open-submenu');
        }
      });
    });

    // Category dropdown toggles
    const categoryToggles = document.querySelectorAll('[data-category-toggle]');
    
    categoryToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const category = this.closest('[data-category]');
        category.classList.toggle('is-open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-countdown]').forEach(countdown => {
    const targetDate = new Date(countdown.dataset.countdown).getTime();
    
    const updateCountdown = () => {
      const now = new Date().getTime();
      const diff = targetDate - now;
      
      if (diff < 0) {
        countdown.style.display = 'none';
        return;
      }
      
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      const daysEl = countdown.querySelector('[data-days]');
      const hoursEl = countdown.querySelector('[data-hours]');
      const minutesEl = countdown.querySelector('[data-minutes]');
      const secondsEl = countdown.querySelector('[data-seconds]');
      
      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    };
    
    updateCountdown();
    setInterval(updateCountdown, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-testimonials-slider]').forEach(slider => {
    const track = slider.querySelector('[data-testimonials-track]');
    const prevBtn = slider.querySelector('[data-testimonials-prev]');
    const nextBtn = slider.querySelector('[data-testimonials-next]');
    const dotsContainer = slider.querySelector('[data-testimonials-dots]');
    const cards = track.querySelectorAll('.testimonial-card');
    
    let currentIndex = 0;
    let slidesPerView = 1;
    
    const updateSlidesPerView = () => {
      if (window.innerWidth >= 1024) slidesPerView = 3;
      else if (window.innerWidth >= 768) slidesPerView = 2;
      else slidesPerView = 1;
    };
    
    const totalSlides = () => Math.ceil(cards.length / slidesPerView);
    
    const updateSlider = () => {
      const slideWidth = 100 / slidesPerView;
      track.style.transform = `translateX(-${currentIndex * slideWidth}%)`;
      updateDots();
    };
    
    const createDots = () => {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      for (let i = 0; i < totalSlides(); i++) {
        const dot = document.createElement('button');
        dot.className = 'testimonials__dot' + (i === 0 ? ' is-active' : '');
        dot.addEventListener('click', () => {
          currentIndex = i;
          updateSlider();
        });
        dotsContainer.appendChild(dot);
      }
    };
    
    const updateDots = () => {
      if (!dotsContainer) return;
      dotsContainer.querySelectorAll('.testimonials__dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    };
    
    const goNext = () => {
      currentIndex = (currentIndex + 1) % totalSlides();
      updateSlider();
    };
    
    const goPrev = () => {
      currentIndex = (currentIndex - 1 + totalSlides()) % totalSlides();
      updateSlider();
    };
    
    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);
    
    updateSlidesPerView();
    createDots();
    
    window.addEventListener('resize', () => {
      updateSlidesPerView();
      currentIndex = 0;
      createDots();
      updateSlider();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
